// extracted by mini-css-extract-plugin
module.exports = {"signInClass":"signin_signInClass__2cJ_y"};